import { createContext } from 'react';

import {
  UbiquitiApiDataItem,
  UbiquitiFirewallPolicy,
} from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  firewallPolicies: UbiquitiApiDataItem<UbiquitiFirewallPolicy>[];
}

export default createContext<Context>({
  loading: false,
  error: false,
  firewallPolicies: [],
});
